import PublicHeader from '../components/PublicHeader';

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-purple-50 to-fuchsia-50">
      <PublicHeader />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold gradient-text mb-3" data-testid="mentions-title">
          Mentions légales
        </h1>
        <p className="text-sm text-gray-500 mb-10">
          Informations réglementaires relatives à l'exploitation du site insitumed.fr.
        </p>

        <div className="bg-white rounded-2xl shadow-lg border border-violet-100 p-8 space-y-8">
          <section>
            <h2 className="text-xl font-bold text-violet-700 mb-3">Éditeur du site</h2>
            <ul className="text-gray-700 space-y-1 text-sm">
              <li><strong>Nom commercial :</strong> Insitumed — Centre de Formation Professionnelle</li>
              <li><strong>Dirigeante :</strong> Sandrine Weber</li>
              <li><strong>Statut juridique :</strong> Profession libérale réglementée</li>
              <li><strong>Date de création :</strong> 1<sup>er</sup> juillet 2025</li>
              <li><strong>SIRET :</strong> 789 332 053 00055</li>
              <li><strong>Code APE (NAF) :</strong> 8559B — Autres enseignements</li>
              <li><strong>Email :</strong> <a href="mailto:insitumed@myyahoo.com" className="text-violet-600 hover:underline">insitumed@myyahoo.com</a></li>
              <li><strong>Site web :</strong> <a href="https://insitumed.fr" className="text-violet-600 hover:underline">insitumed.fr</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-violet-700 mb-3">Hébergement</h2>
            <p className="text-sm text-gray-700">
              Le site insitumed.fr est hébergé par la plateforme Emergent
              (<a href="https://emergent.sh" className="text-violet-600 hover:underline">emergent.sh</a>).
              Le nom de domaine est enregistré chez OVH SAS,
              2 rue Kellermann, 59100 Roubaix, France.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-violet-700 mb-3">Propriété intellectuelle</h2>
            <p className="text-sm text-gray-700">
              L'ensemble des contenus présents sur ce site (textes, images, supports de
              formation, ressources téléchargeables) est la propriété exclusive
              d'Insitumed, sauf mention contraire. Toute reproduction, diffusion ou
              utilisation commerciale sans autorisation écrite préalable est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-violet-700 mb-3">Protection des données personnelles</h2>
            <p className="text-sm text-gray-700 mb-2">
              Les données personnelles collectées lors d'une inscription à une
              formation ou d'un achat de ressource sont utilisées uniquement dans le
              cadre de la relation contractuelle avec Insitumed (envoi des supports,
              suivi pédagogique, facturation).
            </p>
            <p className="text-sm text-gray-700">
              Conformément au Règlement Général sur la Protection des Données (RGPD),
              vous disposez d'un droit d'accès, de rectification et de suppression de
              vos données. Pour toute demande, contactez :{' '}
              <a href="mailto:insitumed@myyahoo.com" className="text-violet-600 hover:underline">
                insitumed@myyahoo.com
              </a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-violet-700 mb-3">Certification qualité</h2>
            <p className="text-sm text-gray-700">
              Les prestations proposées par Insitumed sont réalisées dans le respect
              des principes de la démarche qualité en formation professionnelle
              (analyse des besoins, alignement pédagogique, évaluation des acquis,
              amélioration continue).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-violet-700 mb-3">Contact</h2>
            <p className="text-sm text-gray-700">
              Pour toute question relative au site, aux formations ou aux ressources,
              vous pouvez nous joindre à :{' '}
              <a href="mailto:insitumed@myyahoo.com" className="text-violet-600 hover:underline">
                insitumed@myyahoo.com
              </a>.
            </p>
          </section>
        </div>

        <p className="text-xs text-gray-500 text-center mt-8">
          Dernière mise à jour : février 2026
        </p>
      </main>
    </div>
  );
}
